<script lang="ts" setup>
/* Components */
import HeaderCitySelectDialog from '@/components/Header/HeaderCitySelectDialog.vue'

type Props = {
  isCitySelectListShow?: boolean
  cityName: string
}

defineProps<Props>()

const dialogs = ref({
  citySelect: false,
})

const setDialogs = () => {
  dialogs.value.citySelect = !dialogs.value.citySelect
}
</script>

<template>
  <div class="header-city-select">
    <span
      class="header-city-select__text"
      data-e2e="toggle-city-list"
      @click="setDialogs"
    >
      {{ cityName }}
    </span>

    <header-city-select-dialog
      v-model="dialogs.citySelect"
      :city-name="cityName"
      :is-city-select-list-show="isCitySelectListShow"
    />
  </div>
</template>

<style lang="scss" scoped>
.header-city-select {
  font-size: 12px;
  font-weight: 800;
  line-height: 16px;

  @include media('>=desktop-mini') {
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;
  }

  &__text {
    display: inline-block;
    color: var(--ui-primary);
  }
}
</style>
